function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.483 2 2 6.432 2 11.888c0 5.455 4.483 9.887 10 9.887s10-4.432 10-9.887C22 6.432 17.517 2 12 2zm0 .899c5.026 0 9.09 4.019 9.09 8.989 0 4.97-4.064 8.988-9.09 8.988s-9.09-4.019-9.09-8.988c0-4.97 4.064-8.99 9.09-8.99zm0 2.595c-1.752 0-3.182 1.414-3.182 3.146-.002.163.084.313.226.395.141.082.316.082.458 0 .141-.082.228-.232.225-.395 0-1.246 1.012-2.247 2.273-2.247 1.26 0 2.273 1.001 2.273 2.247.009 1.01-.54 1.553-1.215 2.184-.337.316-.698.638-.994 1.04-.296.402-.519.902-.519 1.496v.224c-.002.162.084.313.226.395.141.082.317.082.458 0 .142-.082.228-.233.226-.395v-.224c0-.386.122-.672.34-.97.22-.297.541-.588.888-.912.693-.648 1.508-1.488 1.499-2.838v-.007C15.178 6.904 13.749 5.494 12 5.494zm0 10.439c-.377 0-.682.301-.682.674 0 .372.305.674.682.674.377 0 .682-.302.682-.674 0-.373-.305-.674-.682-.674z",
  transform: "translate(-120 -491) translate(120 491)"
}))));

var SvgIconHelper = function SvgIconHelper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHelper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-helper.27db6c37.svg";
export { ForwardRef as ReactComponent };